// extracted by mini-css-extract-plugin
module.exports = {"heading":"SecurityDetails_heading__kJl1f","list":"SecurityDetails_list__2UOQh","description":"SecurityDetails_description__Csc-N"};